/*
 * サブシステム名：発注
 * 機能名：未支払発注金額修正一覧
 * 1基本:1明細:1品目版
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'

import validators from '@/rahmen/validators'
import dolly from '@/rahmen/utils/dolly'
import filter from '@/rahmen/utils/filters'
import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDateRangeBox = () => import('@/components/DdDateRangeBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditDialog = () => import('@/components/DdEditDialog')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdListHeader = () => import('@/components/DdListHeader')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')
const DdSubHeader = () => import('@/components/DdSubHeader')

export default {
  name: 'MishiharaiHacchuKingakuList',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCodeTextBox,
    DdDateBox,
    DdDateRangeBox,
    DdDropDown,
    DdEditDialog,
    DdIconButtonWithTooltip,
    DdListHeader,
    DdNarrowDownTextBox,
    DdRadioButton,
    DdSelectItemsPerPage,
    DdSubHeader
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    rows: [],
    conditions: {},
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    modeKengen: 0,
    // 画面表示制御
    // 画面ピクセル制御用
    widthOfLineHeader: [0, 0, 0]
  }),
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      kubunList: 'DDMasters/msysKubun',
      currentKaishaCode: 'users/currentKaishaCode',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.hacchuEigyoshoDisp = elem.hacchuEigyoshoCd ? elem.hacchuEigyoshoCd + ' : ' + elem.hacchuEigyoshoNm : ''
        elem.hacchusakiDisp = elem.hacchusakiCd ? elem.hacchusakiCd + ' : ' + elem.hacchusakiNm : ''
        elem.hatsuchiDisp = elem.hatsuchiCd ? elem.hatsuchiCd + ' : ' + elem.hatsuchiNm : elem.hatsuchiBiko
        elem.hatsuchiYmdDisp = elem.hatsuchiYmd ? filter.dateFormatter(elem.hatsuchiYmd) : ''
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : ''
        elem.keiyuchi1Disp = elem.keiyuchi1Cd ? elem.keiyuchi1Cd + ' : ' + elem.keiyuchi1Nm : elem.keiyuchiId1Biko
        elem.keiyuchi2Disp = elem.keiyuchi2Cd ? elem.keiyuchi2Cd + ' : ' + elem.keiyuchi2Nm : elem.keiyuchiId2Biko
        elem.keiyuchi3Disp = elem.keiyuchi3Cd ? elem.keiyuchi3Cd + ' : ' + elem.keiyuchi3Nm : elem.keiyuchiId3Biko
        elem.keiyuchi4Disp = elem.keiyuchi4Cd ? elem.keiyuchi4Cd + ' : ' + elem.keiyuchi4Nm : elem.keiyuchiId4Biko
        elem.keiyuchi5Disp = elem.keiyuchi5Cd ? elem.keiyuchi5Cd + ' : ' + elem.keiyuchi5Nm : elem.keiyuchiId5Biko
        elem.chakuchiDisp = elem.chakuchiCd ? elem.chakuchiCd + ' : ' + elem.chakuchiNm : elem.chakuchiBiko
        elem.chakuchiYmdDisp = elem.chakuchiYmd ? filter.dateFormatter(elem.chakuchiYmd) : ''
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : ''
        elem.hinmeiDisp = elem.hinmeiCd ? elem.hinmeiCd + ' : ' + elem.hinmeiNm : elem.hinmeiBiko
        elem.hacchuSuryo = elem.hacchuSuryo ? filter.numericFormatter(elem.hacchuSuryo) : ''
        elem.tanka = elem.tanka ? filter.numericFormatter(elem.tanka) : 0
        elem.hacchuJuryo = elem.hacchuJuryo ? filter.numericFormatter(elem.hacchuJuryo) : ''
        elem.shiharaiYoteiYmdDisp = elem.shiharaiYoteiYmd ? filter.dateFormatter(elem.shiharaiYoteiYmd) : ''
        elem.kihonUnchin = elem.kihonUnchin ? filter.numericFormatter(elem.kihonUnchin) : 0
        elem.hokanKingaku = elem.hokanKingaku ? filter.numericFormatter(elem.hokanKingaku) : 0
        elem.niekiKingaku = elem.niekiKingaku ? filter.numericFormatter(elem.niekiKingaku) : 0
        elem.unchinHokaKingaku = elem.unchinHokaKingaku ? filter.numericFormatter(elem.unchinHokaKingaku) : 0
        elem.hiwayPrice = elem.hiwayPrice ? filter.numericFormatter(elem.hiwayPrice) : 0
        elem.unchinHokaHikazei = elem.unchinHokaHikazei ? filter.numericFormatter(elem.unchinHokaHikazei) : 0
        elem.tatekaekinHikazei = elem.tatekaekinHikazei ? filter.numericFormatter(elem.tatekaekinHikazei) : 0
        elem.warimashiJikanTanka = elem.warimashiJikanTanka ? filter.numericFormatter(elem.warimashiJikanTanka) : ''
        elem.jikanWarimashiKingaku = elem.jikanWarimashiKingaku ? filter.numericFormatter(elem.jikanWarimashiKingaku) : 0
        elem.warimashiTaishoKyori = elem.warimashiTaishoKyori ? filter.numericFormatter(elem.warimashiTaishoKyori) : ''
        elem.warimashiKyoriTanka = elem.warimashiKyoriTanka ? filter.numericFormatter(elem.warimashiKyoriTanka) : ''
        elem.kyoriWarimashiKingaku = elem.kyoriWarimashiKingaku ? filter.numericFormatter(elem.kyoriWarimashiKingaku) : 0
        elem.warimashiSonotaKingaku = elem.warimashiSonotaKingaku ? filter.numericFormatter(elem.warimashiSonotaKingaku) : 0
        elem.shiharaiKingakuAmountDisp = elem.shiharaiKingakuAmount ? filter.numericFormatter(elem.shiharaiKingakuAmount) : 0
        elem.memo = elem.editFlg ? '変更中' : '　　　'
        return elem
      })
    },
    // 営業所フィルター
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      })
    },
    // 取引先フィルター
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    // 発注先フィルター
    filteredHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && (t.hacchusakiFlg === true || t.shiiresakiFlg === true)
      })
    },
    // 運賃計算方法区分フィルター
    filteredUnchinKeisanKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF055')
    },
    tableWidthStyle () {
      return {
        '--width-of-1': this.widthOfLineHeader[0] + 'px',
        '--width-of-2': this.widthOfLineHeader[1] + 'px',
        '--width-of-3': this.widthOfLineHeader[2] + 'px'
      }
    },
    // CSVボタン活性条件
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isMultiSaveButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      if (this.rows.length > 0 && this.rows.filter(n => n.editFlg === true).length > 0) {
        return false
      }
      return true
    },
    // 保存ボタン活性条件
    multiSaveButtonDisp () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    },
    isReadOnly () {
      if (this.modeKengen === 0) {
        return true
      }
      return false
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize () {
      console.log('initialize')
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'msttorihikisaki', 'msyskubun'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('PrmHaishaList.defineHeaderPromise')
            this.headers = [
              { text: 'ID', value: 'id', align: ' d-none' },
              { text: '反映', value: 'actions', align: 'center', sortable: false, width: '80px' },
              { text: '変更状況', value: 'memo', align: 'center' },
              { text: '発注No', value: 'hacchuNo' },
              { text: '支払金額合計', value: 'shiharaiKingakuAmountDisp', align: 'end' },
              { text: '発注営業所', value: 'hacchuEigyoshoDisp' },
              { text: '発注先', value: 'hacchusakiDisp' },
              { text: '支払済み', value: 'shiharaiZumiFlgDisp', align: 'center' },
              { text: '運賃確定済み', value: 'unchinKakuteiFlgDisp', align: 'center' },
              { text: '支払止め対象', value: 'shiharaiTomeFlgDisp', align: 'center' },
              { text: '支払計上日', value: 'shiharaiYoteiYmdDisp' },
              { text: '数量', value: 'hacchuSuryo', align: 'end' },
              { text: '単位', value: 'unitKbnNm' },
              { text: '重量(t)', value: 'hacchuJuryo', align: 'end' },
              { text: '単価', value: 'tanka' },
              { text: '運賃計算区分', value: 'unchinKeisanKbn', width: '8vw' },
              { text: '運賃', value: 'kihonUnchin', align: 'end' },
              { text: '運賃(高速)', value: 'hiwayPrice', align: 'end' },
              { text: '運賃(他)', value: 'unchinHokaKingaku', align: 'end' },
              { text: '保管料', value: 'hokanKingaku', align: 'end' },
              { text: '荷役量', value: 'niekiKingaku', align: 'end' },
              { text: '運賃他(非)', value: 'unchinHokaHikazei', align: 'end' },
              { text: '立替金(非)', value: 'tatekaekinHikazei', align: 'end' },
              { text: '割増対象時間', value: 'warimashiTaishoJikan', align: 'center' },
              { text: '割増単価(時間)', value: 'warimashiJikanTanka', align: 'end' },
              { text: '割増金額(時間)', value: 'jikanWarimashiKingaku', align: 'end' },
              { text: '割増距離', value: 'warimashiTaishoKyori', align: 'center' },
              { text: '割増単価(距離)', value: 'warimashiKyoriTanka', align: 'end' },
              { text: '割増金額(距離)', value: 'kyoriWarimashiKingaku', align: 'end' },
              { text: '割増その他', value: 'warimashiSonotaKingaku', align: 'end' },
              { text: '注文番号', value: 'chumonNo' },
              { text: '往復種別', value: 'ohfukuSbtNm' },
              { text: '発地', value: 'hatsuchiDisp' },
              { text: '発地年月日', value: 'hatsuchiYmdDisp' },
              { text: '発地時刻', value: 'hatsuchiHmsDisp' },
              { text: '経由地１', value: 'keiyuchi1Disp' },
              { text: '経由地２', value: 'keiyuchi2Disp' },
              { text: '経由地３', value: 'keiyuchi3Disp' },
              { text: '経由地４', value: 'keiyuchi4Disp' },
              { text: '経由地５', value: 'keiyuchi5Disp' },
              { text: '着地', value: 'chakuchiDisp' },
              { text: '着地年月日', value: 'chakuchiYmdDisp' },
              { text: '着地時刻', value: 'chakuchiHmsDisp' },
              { text: '品名', value: 'hinmeiDisp' },
              { text: '支払車種', value: 'shiharaiShashuSbtNm' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('PrmHaishaList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('PrmHaishaList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('PrmHaishaList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('PrmHaishaList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingViewScroll: () => {
          return false
        },
        settingButtonStatePromise: (kengen) => {
          console.log('PrmHaishaList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2plod004005/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload
          self.rows.map((elem) => {
            elem.editFlg = false
            elem.warimashiTaishoJikan = elem.warimashiTaishoJikan !== null && elem.warimashiTaishoJikan !== undefined ? filter.minToIntervalTimeFormatter(elem.warimashiTaishoJikan) : ''
            return elem
          })
          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              self.calcWidthLineHeader()
              self.cloneRows = dolly.clone(self.getCloneTargetMethod())
            })
        },
        getSavedInputMethod: function () {
          return {
            shiharaiZumiFlgDisp: self.conditions.shiharaiZumiFlgDisp,
            shiharaiTomeFlgDisp: self.conditions.shiharaiTomeFlgDisp,
            unchinKakuteiFlgDisp: self.conditions.unchinKakuteiFlgDisp
          }
        }
      }
      this.search(opt)
    },
    // 検索前チェック
    searchValidate: function () {
      // 支払予定年月日不整合チェック
      if (this.conditions.shiharaiStartYmdString && this.conditions.shiharaiEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.shiharaiStartYmdString, this.conditions.shiharaiEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.shiharaiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.shiharaiEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      return true
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.initBindVariables()
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onCsvButtonClick: function (e) {
      this.Effects.loadStart()
      this.HttpClient
        .post('/api/v1/VwCD2plod004005/download', this.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '支払金額一括修正_' + ts + '.csv'
          elem.click()
          this.Effects.loadComplete()
        })
    },
    /**
   * 更新後の再取得 ※対象行のデータとClone情報を差し替える
   * @param {} recId
   * @param {*} rowIndex
   * @returns
   */
    getData: function (recId, rowIndex) {
      // サマリメッセージ初期化
      // this.clearSummaryMessage()

      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/VwCD2plod004005/find?id=${recId}`)
          .then((data) => {
            const rec = data.payload
            // 取得データを差し替え
            rec.editFlg = false
            rec.memo = ''
            rec.warimashiTaishoJikan = rec.warimashiTaishoJikan !== null && rec.warimashiTaishoJikan !== undefined ? filter.minToIntervalTimeFormatter(rec.warimashiTaishoJikan) : ''
            Object.assign(this.rows[rowIndex], rec)
            // CloneData更新
            this.cloneRows = dolly.clone(this.getCloneTargetMethod())
            // 画面への再描写 ※強制発火用にspliceを実行
            this.rows.splice()
            resolve()
          })
      })
    },
    onSave: function (item) {
      this.Effects.loadStart()
      const index = this.rows.indexOf(item)
      const saveTagetRow = this.rows.filter(n => n.id === item.id)
      saveTagetRow.map((elem) => {
        elem.hacchuSuryo = elem.hacchuSuryo ? this.getNullValue(elem.hacchuSuryo) : null
        elem.tanka = elem.tanka ? this.getNullValue(elem.tanka) : null
        elem.hacchuJuryo = elem.hacchuJuryo ? this.getNullValue(elem.hacchuJuryo) : null
        elem.kihonUnchin = elem.kihonUnchin ? this.getNullValue(elem.kihonUnchin) : null
        elem.hokanKingaku = elem.hokanKingaku ? this.getNullValue(elem.hokanKingaku) : null
        elem.niekiKingaku = elem.niekiKingaku ? this.getNullValue(elem.niekiKingaku) : null
        elem.unchinHokaKingaku = elem.unchinHokaKingaku ? this.getNullValue(elem.unchinHokaKingaku) : null
        elem.hiwayPrice = elem.hiwayPrice ? this.getNullValue(elem.hiwayPrice) : null
        elem.unchinHokaHikazei = elem.unchinHokaHikazei ? this.getNullValue(elem.unchinHokaHikazei) : null
        elem.tatekaekinHikazei = elem.tatekaekinHikazei ? this.getNullValue(elem.tatekaekinHikazei) : null
        elem.warimashiTaishoJikan = elem.warimashiTaishoJikan ? filter.timeToMinFormatter(elem.warimashiTaishoJikan) : null
        elem.warimashiJikanTanka = elem.warimashiJikanTanka ? this.getNullValue(elem.warimashiJikanTanka) : null
        elem.jikanWarimashiKingaku = elem.jikanWarimashiKingaku ? this.getNullValue(elem.jikanWarimashiKingaku) : null
        elem.warimashiTaishoKyori = elem.warimashiTaishoKyori ? this.getNullValue(elem.warimashiTaishoKyori) : null
        elem.warimashiKyoriTanka = elem.warimashiKyoriTanka ? this.getNullValue(elem.warimashiKyoriTanka) : null
        elem.kyoriWarimashiKingaku = elem.kyoriWarimashiKingaku ? this.getNullValue(elem.kyoriWarimashiKingaku) : null
        elem.warimashiSonotaKingaku = elem.warimashiSonotaKingaku ? this.getNullValue(elem.warimashiSonotaKingaku) : null
        return elem
      })
      this.saveAction(saveTagetRow, index, 0)
    },
    onMultiSaveButtonClick: function (e) {
      this.Effects.loadStart()
      const saveTagetRow = this.rows.filter(n => n.editFlg === true)
      saveTagetRow.map((elem) => {
        elem.hacchuSuryo = elem.hacchuSuryo ? this.getNullValue(elem.hacchuSuryo) : null
        elem.tanka = elem.tanka ? this.getNullValue(elem.tanka) : null
        elem.hacchuJuryo = elem.hacchuJuryo ? this.getNullValue(elem.hacchuJuryo) : null
        elem.kihonUnchin = elem.kihonUnchin ? this.getNullValue(elem.kihonUnchin) : null
        elem.hokanKingaku = elem.hokanKingaku ? this.getNullValue(elem.hokanKingaku) : null
        elem.niekiKingaku = elem.niekiKingaku ? this.getNullValue(elem.niekiKingaku) : null
        elem.unchinHokaKingaku = elem.unchinHokaKingaku ? this.getNullValue(elem.unchinHokaKingaku) : null
        elem.hiwayPrice = elem.hiwayPrice ? this.getNullValue(elem.hiwayPrice) : null
        elem.unchinHokaHikazei = elem.unchinHokaHikazei ? this.getNullValue(elem.unchinHokaHikazei) : null
        elem.tatekaekinHikazei = elem.tatekaekinHikazei ? this.getNullValue(elem.tatekaekinHikazei) : null
        elem.warimashiTaishoJikan = elem.warimashiTaishoJikan ? filter.timeToMinFormatter(elem.warimashiTaishoJikan) : null
        elem.warimashiJikanTanka = elem.warimashiJikanTanka ? this.getNullValue(elem.warimashiJikanTanka) : null
        elem.jikanWarimashiKingaku = elem.jikanWarimashiKingaku ? this.getNullValue(elem.jikanWarimashiKingaku) : null
        elem.warimashiTaishoKyori = elem.warimashiTaishoKyori ? this.getNullValue(elem.warimashiTaishoKyori) : null
        elem.warimashiKyoriTanka = elem.warimashiKyoriTanka ? this.getNullValue(elem.warimashiKyoriTanka) : null
        elem.kyoriWarimashiKingaku = elem.kyoriWarimashiKingaku ? this.getNullValue(elem.kyoriWarimashiKingaku) : null
        elem.warimashiSonotaKingaku = elem.warimashiSonotaKingaku ? this.getNullValue(elem.warimashiSonotaKingaku) : null
        return elem
      })
      this.saveAction(saveTagetRow, 0, 1)
    },
    saveAction: function (p, index, mode) {
      const self = this
      const opt = {
        registerRequestPromise: function () {
          return self.HttpClient.post('/api/v1/VwCD2plod004005/UpdateHacchuInfo', p)
        },
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            if (mode === 1) {
              self.onSearchButtonClick()
            } else {
              self.getData(p[0].id, index)
            }
            self.Effects.loadComplete()
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return false
        },
        getSavedInputMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    registerPromise: function (p) {
      // 更新処理実行
      // 自レコードのみを更新する
      var rtn = this.HttpClient.post('/api/v1/VwCD2plod004005/UpdateHacchuInfo', p)
      return rtn
    },
    // 登録前チェック
    registerValidate: function () {
      return true
    },
    onEditCloseKihonUnchinPiece: function (e, row) {
      if (e === true && isFinite(this.getNullValue(row.value))) {
        const index = this.rows.indexOf(row.item)
        const rec = Object.assign({}, row.item)
        rec.kihonUnchin = this.calcUnchin(rec)
        rec.shiharaiKingakuAmount = this.calcShiharaiKingaku(rec)
        // 変更フラグ判定（≠Clone値は変更有とみなす）
        if (this.isChanged(rec, this.cloneRows.rows[index])) {
          rec.editFlg = true
        } else {
          rec.editFlg = false
        }

        Object.assign(this.rows[index], rec)
        // 画面への再描写 ※強制発火用にspliceを実行
        this.rows.splice()
      }
    },
    onEditCloseWarimashiJikanPiece: function (e, row) {
      // /* eslint no-debugger: "warn" */
      // debugger
      if (e === true) {
        // filter.timeToMinFormatter(row.value)
        const index = this.rows.indexOf(row.item)
        const rec = Object.assign({}, row.item)
        rec.warimashiTaishoJikan = rec.warimashiTaishoJikan ? this.calcTime(String(rec.warimashiTaishoJikan)) : ''
        rec.jikanWarimashiKingaku = this.calcJikanWarimashiKingaku(rec)
        rec.shiharaiKingakuAmount = this.calcShiharaiKingaku(rec)
        // 変更フラグ判定（≠Clone値は変更有とみなす）
        if (this.isChanged(rec, this.cloneRows.rows[index])) {
          rec.editFlg = true
        } else {
          rec.editFlg = false
        }

        Object.assign(this.rows[index], rec)
        // 画面への再描写 ※強制発火用にspliceを実行
        this.rows.splice()
      }
    },
    onEditCloseWarimashiKyoriPiece: function (e, row) {
      if (e === true && isFinite(this.getNullValue(row.value))) {
        const index = this.rows.indexOf(row.item)
        const rec = Object.assign({}, row.item)
        rec.kyoriWarimashiKingaku = this.calcKyoriWarimashiKingaku(rec)
        rec.shiharaiKingakuAmount = this.calcShiharaiKingaku(rec)
        // 変更フラグ判定（≠Clone値は変更有とみなす）
        if (this.isChanged(rec, this.cloneRows.rows[index])) {
          rec.editFlg = true
        } else {
          rec.editFlg = false
        }

        Object.assign(this.rows[index], rec)
        // 画面への再描写 ※強制発火用にspliceを実行
        this.rows.splice()
      }
    },
    onEditCloseNum: function (e, row) {
      if (e === true && isFinite(this.getNullValue(row.value))) {
        const index = this.rows.indexOf(row.item)
        const rec = Object.assign({}, row.item)
        rec.shiharaiKingakuAmount = this.calcShiharaiKingaku(rec)
        // 変更フラグ判定（≠Clone値は変更有とみなす）
        if (this.isChanged(rec, this.cloneRows.rows[index])) {
          rec.editFlg = true
        } else {
          rec.editFlg = false
        }

        Object.assign(this.rows[index], rec)
        // 画面への再描写 ※強制発火用にspliceを実行
        this.rows.splice()
      }
    },
    onEditCloseKeisanKbn: function (e, row) {
      console.log(e, row)
      const index = this.rows.indexOf(row.item)
      const rec = Object.assign({}, row.item)
      rec.unchinKeisanKbn = e
      rec.kihonUnchin = this.calcUnchin(rec)
      rec.shiharaiKingakuAmount = this.calcShiharaiKingaku(rec)
      // 変更フラグ判定（≠Clone値は変更有とみなす）
      if (this.isChanged(rec, this.cloneRows.rows[index])) {
        rec.editFlg = true
      } else {
        rec.editFlg = false
      }

      Object.assign(this.rows[index], rec)
      // 画面への再描写 ※強制発火用にspliceを実行
      this.rows.splice()
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const d = new Date()
      const initConditions = {
        shiharaiStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        shiharaiEndYmdString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
        hacchusakiCd: null,
        hacchuEigyoshoCd: this.userEigyoshoCd,
        shiharaiZumiFlgDisp: '0',
        shiharaiTomeFlgDisp: '0',
        unchinKakuteiFlgDisp: '0'
      }
      this.widthOfLineHeader = [0, 0, 0]
      this.conditions = initConditions
      this.searchText = ''
      this.rows = []
    },
    calcWidthLineHeader () {
      var i
      const t = new Array(3) // this.widthOfLineHeader = []
      var tables = document.getElementsByTagName('table')
      var row = tables[0].getElementsByTagName('tr')[0].cells
      let width = 0
      for (i = 1; i <= 3; i++) {
        width = width + row[i].offsetWidth
        t[i - 1] = width
      }
      if (t.toString() !== this.widthOfLineHeader.toString()) {
        console.log('width changed')
        this.widthOfLineHeader = t
      }
    },
    onCancel: function (item) {
      // サマリメッセージ初期化
      this.clearSummaryMessage()

      const index = this.rows.indexOf(item)
      this.getData(item.id, index)
    },
    isChanged: function (a, b) {
      if (a.hacchuSuryo !== b.hacchuSuryo ||
          a.hacchuJuryo !== b.hacchuJuryo ||
          a.tanka !== b.tanka ||
          a.unchinKeisanKbn !== b.unchinKeisanKbn ||
          a.hiwayPrice !== b.hiwayPrice ||
          a.unchinHokaKingaku !== b.unchinHokaKingaku ||
          a.hokanKingaku !== b.hokanKingaku ||
          a.niekiKingaku !== b.niekiKingaku ||
          a.unchinHokaHikazei !== b.unchinHokaHikazei ||
          a.tatekaekinHikazei !== b.tatekaekinHikazei ||
          a.warimashiTaishoJikan !== b.warimashiTaishoJikan ||
          a.warimashiJikanTanka !== b.warimashiJikanTanka ||
          a.warimashiTaishoKyori !== b.warimashiTaishoKyori ||
          a.warimashiKyoriTanka !== b.warimashiKyoriTanka ||
          a.warimashiSonotaKingaku !== b.warimashiSonotaKingaku) {
        return true
      } else {
        return false
      }
    },
    // Nullをゼロに変換(カンマ除去も)
    getNullValue (inputValue) {
      if (inputValue === null) { return '0' }
      if (inputValue === undefined) { return '0' }
      if (inputValue === '') { return '0' }
      return this.removeComma(inputValue)
    },
    removeComma: function (num) {
      if (!num) { return '0' }

      if (window.isFinite(num) === true) {
        return num.toString()
      }
      var removedNum = num.replace(/,/g, '')
      return removedNum
    },
    calcTime: function (p) {
      var result = ''
      if (p.indexOf(':') !== -1) {
        p = p.replace(':', '')
      }
      if (p.length < 3) {
        result = filter.minToIntervalTimeFormatter(parseInt(p, 10))
      } else {
        var min = parseInt(p.slice(0, p.length - 2), 10) * 60 + parseInt(p.slice(-2), 10)
        result = filter.minToIntervalTimeFormatter(min)
      }
      return result
    },
    calcShiharaiKingaku: function (p) {
      let amount = 0
      amount = parseInt(this.getNullValue(p.kihonUnchin), 10) +
                parseInt(this.getNullValue(p.hiwayPrice), 10) +
                parseInt(this.getNullValue(p.unchinHokaKingaku), 10) +
                parseInt(this.getNullValue(p.hokanKingaku), 10) +
                parseInt(this.getNullValue(p.niekiKingaku), 10) +
                parseInt(this.getNullValue(p.unchinHokaHikazei), 10) +
                parseInt(this.getNullValue(p.tatekaekinHikazei), 10) +
                parseInt(this.getNullValue(p.jikanWarimashiKingaku), 10) +
                parseInt(this.getNullValue(p.kyoriWarimashiKingaku), 10) +
                parseInt(this.getNullValue(p.warimashiSonotaKingaku), 10)
      return amount
    },
    calcUnchin: function (p) {
      let amount = 0

      const tanka = parseFloat(this.getNullValue(p.tanka), 10)

      if (p.unchinKeisanKbn === '01') {
        amount = tanka * parseFloat(this.getNullValue(p.hacchuSuryo), 10)
      } else if (p.unchinKeisanKbn === '02') {
        amount = tanka * parseFloat(this.getNullValue(p.hacchuJuryo), 10)
      } else if (p.unchinKeisanKbn === '03') {
        amount = tanka
      }
      amount = this.calcFraction(p, amount)
      return amount
    },
    calcJikanWarimashiKingaku: function (p) {
      let warimashiTaishoJikan = p.warimashiTaishoJikan

      if (warimashiTaishoJikan === undefined || warimashiTaishoJikan === '' || warimashiTaishoJikan === null) { warimashiTaishoJikan = '00:00' }
      warimashiTaishoJikan = filter.timeToMinFormatter(warimashiTaishoJikan)

      return this.calcFraction(p, (warimashiTaishoJikan / 60) * parseFloat(this.getNullValue(p.warimashiJikanTanka), 10))
    },
    calcKyoriWarimashiKingaku: function (p) {
      return this.calcFraction(p, parseFloat(this.getNullValue(p.warimashiTaishoKyori), 10) * parseFloat(this.getNullValue(p.warimashiKyoriTanka), 10))
    },
    calcFraction: function (p, amount) {
      if (!p.unchinHasuKeisanKbn) {
      // 初期設定は四捨五入としておく
        amount = Math.round(amount)
      } else if (p.unchinHasuKeisanKbn === '01') {
      // 切り捨て
        amount = Math.floor(amount)
      } else if (p.unchinHasuKeisanKbn === '02') {
      // 四捨五入
        amount = Math.round(amount)
      } else if (p.unchinHasuKeisanKbn === '03') {
      // 切り上げ
        amount = Math.ceil(amount)
      }
      return amount
    },
    // ページ操作
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    // ダミー
    onDummyFunction: function () {
      this.$emit('dummy')
    }
  }
}
